import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { updateEventCheckin, createEventCheckin } from '@/redux/actions';

const WS_EVENTS_BY_HTTP = {
	CREATE: 'event/:eventID/checkin/POST',
	DELETE: 'event/:eventID/checkin/:checkinID/DELETE',
	UPDATE: 'event/:eventID/checkin/:checkinID/PATCH',
};

const EventCheckinSubscriptions = props => {
	const {
		socket,
		children,
		currentEventId,
		checkins,
		updateEventCheckin,
		createEventCheckin,
	} = props;

	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToCheckins = () => {
		socket.emit('event/:eventID/checkin/SUBSCRIBE', { eventID: currentEventId });
		console.log('⚡️ EventCheckinSubscriptions Mounted ⚡️', checkins);
	};

	const unsubscribeToCheckins = () => {
		socket.emit('event/:eventID/checkin/UNSUBSCRIBE', { eventID: currentEventId });
		console.log(`🚶‍♂️ EventCheckinSubscriptions Unmounted 🚶‍♂️`, checkins);
	};

	const listenForUpdatedEventCheckin = () =>
		socket.on(WS_EVENTS_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error updating event checkin', error);
			else {
				updateEventCheckin(data);
				displayMessage('Event Check-In Updated');
			}
		});

	const listenForCreatedEventCheckin = () =>
		socket.on(WS_EVENTS_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error Creating Event Checkin', error);
			else {
				createEventCheckin(data);
				displayMessage('Event Check-In created');
			}
		});

	const listeners = () => [listenForCreatedEventCheckin, listenForUpdatedEventCheckin];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToCheckins}
				unsub={unsubscribeToCheckins}
				listeners={listeners()}
				routes={Object.values(WS_EVENTS_BY_HTTP)}
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	updateEventCheckin: eventCheckin => dispatch(updateEventCheckin(eventCheckin)),
	createEventCheckin: eventCheckin => dispatch(createEventCheckin(eventCheckin)),
});

export default connect(msp, mdp)(EventCheckinSubscriptions);
